/**
 * Formats a person's name for display.
 *
 * @param nameObj - should have the following (but not required):
 *                  nickName, firstName, lastName.
 */
export default function formatName(nameObj) {
  if (nameObj == null) {
    return nameObj
  }
  const nickName = nameObj.nickName
  const firstName = nameObj.firstName
  const lastName = nameObj.lastName
  if (nickName) {
    return nickName
  } else if (firstName && lastName) {
    return `${firstName} ${lastName.substring(0, 1)}`
  } else if (firstName) {
    return firstName
  } else if (lastName) {
    return lastName
  }
  return ''
}
